import { render, staticRenderFns } from "./AppListCoop.vue?vue&type=template&id=005af875&"
import script from "./AppListCoop.vue?vue&type=script&lang=ts&"
export * from "./AppListCoop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports